import React, { useEffect, useState } from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients/Patients';
import Doctors from './pages/Doctors/Doctors';
import PatientRecords from './pages/Patients/PatientRecords';
import PrivateRoute from './components/PrivateRoute'; // Import PrivateRoute
import { isLoggedIn } from './services/authService';

function App() {
    const [authState, setAuthState] = useState({ checked: false, isAuthenticated: false });

    useEffect(() => {
        let mounted = true;
        (async () => {
            const res = await isLoggedIn();
            if (mounted) {
                setAuthState({ checked: true, isAuthenticated: res.loggedIn });
            }
        })();
        return () => { mounted = false; };
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/dashboard" element={<PrivateRoute element={Dashboard} isAuthenticated={authState.isAuthenticated} loading={!authState.checked} />} />
                <Route path="/doctors" element={<PrivateRoute element={Doctors} isAuthenticated={authState.isAuthenticated} loading={!authState.checked} />} />
                <Route path="/patients" element={<PrivateRoute element={Patients} isAuthenticated={authState.isAuthenticated} loading={!authState.checked} />} />
                <Route path="/patients/:id/records" element={<PrivateRoute element={PatientRecords} isAuthenticated={authState.isAuthenticated} loading={!authState.checked} />} />
            </Routes>
        </Router>
    );
}

export default App;
